var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRdLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 52,
    viewBox: "0 0 48 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.832 5.41782H11.9272V8.39877H26.832V5.41782Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7749 10.6388H20.8701V13.6198H35.7749V10.6388Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8891 10.6388H11.9272V13.6198H17.8891V10.6388Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6987 18.2094H0V21.1904H47.6987V18.2094Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47314 23.4269V51.0034H43.229V23.4269H40.2481V48.0224H7.4541V23.4269H4.47314Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47314 15.9727H7.4541V3.30452H28.3243V15.2248L40.2481 15.2601V15.9656H43.2396V13.7714C43.2406 13.5748 43.2024 13.3799 43.1273 13.1982C43.0522 13.0165 42.9417 12.8516 42.8022 12.713L30.8784 0.757483C30.74 0.617679 30.5752 0.506956 30.3934 0.431831C30.2117 0.356706 30.0167 0.318697 29.82 0.320042H4.47314V15.9727Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3408 23.7407H24.0944V26.503C25.0705 25.6344 26.1933 24.9463 27.4104 24.471H27.4492C27.888 24.3057 28.3604 24.2496 28.8256 24.3074C29.2909 24.3653 29.7351 24.5353 30.1201 24.803C30.505 25.0706 30.8191 25.4278 31.0354 25.8437C31.2517 26.2597 31.3636 26.722 31.3615 27.1909V27.5049C30.0816 27.4905 28.8219 27.8247 27.7174 28.4715C26.6316 29.1092 25.7269 30.0139 25.0892 31.0996C24.4356 32.2083 24.0977 33.4746 24.112 34.7614V45.7821H20.3408V23.7407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdLogo);
export default __webpack_public_path__ + "static/media/rd_logo.e9f0a933681494f7ffaf9c6e44608cc4.svg";
export { ForwardRef as ReactComponent };